import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWhiteboard1"><Path d="M13 2H11V4H2V19H6.61257L5.73509 21.6325L7.63246 22.2649L8.72076 19H11V21H13V19H15.2792L16.3675 22.2649L18.2649 21.6325L17.3874 19H22V4H13V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWhiteboard1;
